import { Box } from "@mui/material";
import { FC, useState } from "react";
import { getPsychologistServicesSummary, PsychologistServicesSummary } from "src/apis/psychologist";
import { getServices, Service } from "src/apis/services";
import PageContainer from "src/pages/components/PageContainer";
import PsychologistSelect from "src/pages/components/PsychologistSelect";
import FilterButtons from "src/pages/components/SearchAndResetButtons";
import StartAndEndDateFilters from "src/pages/components/StartAndEndDateFilters";
import SummaryFab from "src/pages/components/SummaryFab";
import { getFirstDayOfMonth, getLastDayOfMonth } from "src/utils/date";
import { Id } from "src/utils/types";
import ServicesByPsychologistSummaryTable from "./components/ServicesByPsychologistSummaryTable";
import ServicesTable from "src/pages/components/ServicesTable";

const ServicesByPsychologist: FC = (): JSX.Element => {
  const [error, setError] = useState<string>('');
  const [psychologistId, setPsychologistId] = useState<Id|undefined>();
  const [services, setServices] = useState<Service[]>([]);
  const [summary, setSummary] = useState<PsychologistServicesSummary|null>(null);
  const [startDate, setStartDate] = useState<string>(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState<string>(getLastDayOfMonth());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchServices = async (): Promise<void> => {
    if (!psychologistId) return;

    setIsLoading(true);

    try {
      const resServices = await getServices(
        startDate,
        endDate,
        psychologistId
      );

      setServices(resServices);

      if (resServices.length > 0) {
        const resSummary = await getPsychologistServicesSummary(
          startDate,
          endDate,
          psychologistId
        );
        setSummary(resSummary);
      }

      setError('')
    } catch (err: any) {
      setError(err?.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <PageContainer title="Atendimentos por psicólogo" error={error}>
      {Boolean(summary) && (
        <SummaryFab>
          <ServicesByPsychologistSummaryTable
            summary={summary!}
            startDate={startDate}
            endDate={endDate}
          />
        </SummaryFab>
      )}

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <PsychologistSelect
          isFilter
          setError={setError}
          psychologistId={psychologistId}
          setPsychologistId={setPsychologistId}
        />
        <StartAndEndDateFilters
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
        <FilterButtons
          isLoading={isLoading}
          isDisabled={!psychologistId}
          search={() => {
            fetchServices();
          }}
          resetState={() => {
            setPsychologistId('');
            setServices([]);
            setSummary(null);
          }}
        />
      </Box>

      <Box>
        <ServicesTable services={services} />
      </Box>
    </PageContainer>
  );
}

export default ServicesByPsychologist;
